<template>
  <div class="fullscreen">
    <div class="main-title">使用帮助/互动功能/霸屏</div>
    <h1 class="page-title">霸屏</h1>
    <h4 class="content-text">用户扫码进入互动后，点击手机端右下角"土豪礼物"，可以送出对应礼物，手机端与大屏端同步实时展示。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-fullscreen1_176828695538147c168.webp"
      alt="大屏互动酒吧照片霸屏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-fullscreen2_17682869553826ec532.webp"
      alt="大屏互动酒吧霸屏特效"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-fullscreen3_176828695538295f693.webp"
      alt="大屏互动酒吧重金霸屏"
      class="example-image"
    />
  </div>
</template>

<script>
export default {
  name: 'Fullscreen',
};
</script>

<style lang="less" scoped>
.fullscreen {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
